(function () {
  var currentScript = document.currentScript;
  var dataset = currentScript ? currentScript.dataset : {};
  var skipHeaderTransparency = dataset.skip === 'true';
  var textColorClass = 'text-' + (dataset.textColor || '');
  var textColorScrollClass = 'text-' + (dataset.textColorScroll || '');
  var strokeColorClass = 'stroke-' + (dataset.textColor || '');
  var strokeColorScrollClass = 'stroke-' + (dataset.textColorScroll || '');

  function verifyHeader() {
    if (skipHeaderTransparency) {
      return;
    }
    const headerMenu = document.querySelector('.header-transparent');
    const url = window.location.pathname;
    const isSearchPage = url.includes('/search');
    const isPersonalShopperPage = url.includes('/pages/personal-shopper');
    const isVendedoresPage = url.includes('/pages/vendedores');
    const isWhiteHeaderPage = isPersonalShopperPage || isVendedoresPage;
    const isHomePage = url === '/' || url === '/index';
    const keepTransparentOnScroll = isHomePage;
    let invert = false;
    let alwaysScroll = false;

    if (isHomePage) {
        invert = false;
    } else if (/\/products\/.+/.test(url)) {
        invert = false;
        alwaysScroll = false;
    } else {
        alwaysScroll = true;
        invert = true;
    }

    const headerElements = {
        headerMenu: {
            item: document.querySelector('.header-transparent'),
            class: 'bg-transparent',
            classScroll: 'bg-scroll',
            alwaysScrollChange: isSearchPage || isWhiteHeaderPage
        },
        logoDefault: {
            item: document.querySelector('.logo_default'),
            class: 'turn-on-logo',
            classScroll: 'turn-off-logo'
        },
        logoAlt: {
            item: document.querySelector('.logo_alt'),
            class: 'turn-off-logo',
            classScroll: 'turn-on-logo'
        },
        textMenu: {
            item: document.querySelectorAll('.header__menu-item span, .mega-menu .header__menu-item, .header__menu-item'),
            class: textColorClass,
            classScroll: textColorScrollClass
        },
        textLanguage: {
            item: document.querySelectorAll('.localization-selector.link'),
            class: textColorClass,
            classScroll: textColorScrollClass
        },
        imgIcons: {
            item: document.querySelectorAll('.header__icon'),
            class: textColorClass,
            classScroll: textColorScrollClass
        },
        iconWishlist: {
            item: document.querySelectorAll('.icon-wishlist path'),
            class: strokeColorClass,
            classScroll: strokeColorScrollClass
        },
        textSearchTrigger: {
            item: document.querySelectorAll('.ec-search-modal__text-trigger, .ec-search-modal__text-trigger-label'),
            class: textColorClass,
            classScroll: textColorScrollClass
        }
    }

    function handleScrollHeaderElements() {
        const headerWrapper = document.querySelector('.header-wrapper.header-transparent');
        const isScrolled = window.scrollY > 0;

        if (keepTransparentOnScroll && headerWrapper) {
            headerWrapper.classList.toggle('home-header-scrolled', isScrolled);
        }

        function itemSwitch(item, element) {
            if (!item) return;

            let isScroll = isScrolled;
            if (invert) isScroll = !isScroll;
            if (alwaysScroll) isScroll = true;
            if (element.alwaysScrollChange == false) {
                isScroll = isScrolled;
            }

            if (keepTransparentOnScroll) {
                isScroll = false;
            }

            item.classList.remove(isScroll ? element.class : element.classScroll);
            item.classList.add(isScroll ? element.classScroll : element.class);
        }

        for (const key in headerElements) {
            if (headerElements.hasOwnProperty(key)) {
                const element = headerElements[key];
                if (element.item instanceof NodeList) {
                    element.item.forEach(item => {
                        itemSwitch(item, element);
                    });
                } else {
                    itemSwitch(element.item, element);
                }
            }
        }
    }

    window.addEventListener('scroll', handleScrollHeaderElements);
    handleScrollHeaderElements();
  }

  // Aplicar imediatamente para evitar layout shift
  verifyHeader();

  document.addEventListener('DOMContentLoaded', function () {
    verifyHeader();
    initHeaderTransparentModalState();
  });

  window.syncHeaderTransparentModalState = function () {
    const headerWrapper = document.querySelector('.header-wrapper.header-transparent');
    if (!headerWrapper) return;

    const header = headerWrapper.querySelector('.header');
    const sectionHeader = document.querySelector('.section-header');
    const hasOpenDetails = header ? !!header.querySelector('details[open]') : false;
    const hasMenuOpen = sectionHeader ? sectionHeader.classList.contains('menu-open') : false;
    const hasVisibleInlineMenu = header
      ? Array.from(header.querySelectorAll('.header__inline-menu[data-menu]')).some(function (nav) {
          return nav.classList.contains('header__inline-menu--open') || window.getComputedStyle(nav).display !== 'none';
        })
      : false;
    const hasOpenMegaMenu = header ? !!header.querySelector('details.mega-menu[open]') : false;

    headerWrapper.classList.toggle(
      'header-modal-open',
      hasOpenDetails || hasMenuOpen || hasVisibleInlineMenu || hasOpenMegaMenu
    );
  };

  function bindHeaderMenuModalListeners(header) {
    if (!header || header.dataset.ecModalListenersBound === 'true') return;
    header.dataset.ecModalListenersBound = 'true';

    header.querySelectorAll('details').forEach(function (detail) {
      detail.addEventListener('toggle', window.syncHeaderTransparentModalState);
    });

    header.querySelectorAll('header-menu > details.mega-menu').forEach(function (detail) {
      detail.addEventListener('mouseenter', function () {
        detail.setAttribute('open', '');
        window.syncHeaderTransparentModalState();
      });
      detail.addEventListener('mouseleave', function () {
        detail.removeAttribute('open');
        window.syncHeaderTransparentModalState();
      });
    });

    header.querySelectorAll('.header__inline-menu-top, .header__inline-menu[data-menu]').forEach(function (menuNode) {
      menuNode.addEventListener('mouseenter', window.syncHeaderTransparentModalState);
      menuNode.addEventListener('mouseleave', window.syncHeaderTransparentModalState);
    });

    header.addEventListener('mouseenter', window.syncHeaderTransparentModalState);
    header.addEventListener('mouseleave', window.syncHeaderTransparentModalState);
  }

  function initHeaderTransparentModalState() {
    const headerWrapper = document.querySelector('.header-wrapper.header-transparent');
    if (!headerWrapper) return;

    const header = headerWrapper.querySelector('.header');
    const sectionHeader = document.querySelector('.section-header');

    window.syncHeaderTransparentModalState();

    if (header) {
      bindHeaderMenuModalListeners(header);

      const modalObserver = new MutationObserver(window.syncHeaderTransparentModalState);
      modalObserver.observe(header, {
        attributes: true,
        attributeFilter: ['open', 'style', 'class'],
        subtree: true,
      });
    }

    if (sectionHeader) {
      const sectionObserver = new MutationObserver(window.syncHeaderTransparentModalState);
      sectionObserver.observe(sectionHeader, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    document.addEventListener('click', window.syncHeaderTransparentModalState);
    document.addEventListener('focusin', window.syncHeaderTransparentModalState);
  }
})();
